import { useTranslation } from "react-i18next";
const CardProjects = ({
  img,
  linkPage,
  linkCode,
  transition,
  comingSoon,
  tecnologies,
}) => {
  const [t] = useTranslation("global");

  return (
    <div className="card-project" data-aos={transition}>
      <div>
        <img className="imgProject" src={img} alt="ImgProject" />
      </div>
      {comingSoon ? (
        <h3> {t("Projects.commingSoon")} </h3>
      ) : (
        <>
          <div style={{ marginTop: 5, marginBottom: 10 }}>
            <label>{t("Projects.tecnologies")}</label>
            <div style={{ columnCount: tecnologies.length / 2 }}>
              {tecnologies.map((t) => {
                return <h6>{t}</h6>;
              })}
            </div>
          </div>

          <div style={{ display: "inline" }}>
            <button className="btn btn-primary" disabled={linkPage == null}>
              <a
                href={linkPage}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                <i className="fa fa-chrome"></i> {t("Projects.btn_page")}
              </a>
            </button>
            <button className="btn btn-dark" disabled={linkCode == null}>
              <a
                href={linkCode}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "white" }}
              >
                <i className="fa fa-github"></i> {t("Projects.btn_code")}
              </a>
            </button>
          </div>
        </>
      )}
    </div>
  );
};
export default CardProjects;
